// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export enum ApiMediaUploadMimeType {
    ImagePng = 'image/png',
    ImageJpeg = 'image/jpeg',
    ImageJpg = 'image/jpg',
    ImageGif = 'image/gif',
    VideoMp4 = 'video/mp4',
    VideoXMsvideo = 'video/x-msvideo',
    AudioMpeg = 'audio/mpeg',
    AudioMpeg3 = 'audio/mpeg3',
    AudioOgg = 'audio/ogg',
    AudioMp3 = 'audio/mp3',
    AudioWav = 'audio/wav',
    AudioAac = 'audio/aac',
    AudioXAac = 'audio/x-aac',
    ModelGltfBinary = 'model/gltf-binary',
    VideoQuicktime = 'video/quicktime',
    ImageWebp = 'image/webp',
    ApplicationPdf = 'application/pdf',
    TextCsv = 'text/csv'
}
